module.exports = __webpack_public_path__ + "img/圆角矩形 3 拷贝 6.3cb096ab.png";